import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TableComponent {
  @Input({ required: true }) data!: Observable<readonly unknown[]>;
  @Input() caption = 'Data Table';
  @Input() columnCount = 1;
  @Input() loading = false;
  @Input() emptyMessage = 'No records found.';
  @ContentChild('headers', { read: TemplateRef }) headers!: TemplateRef<unknown>;
  @ContentChild('rows', { read: TemplateRef }) rows!: TemplateRef<unknown>;
}
